import { cva } from 'class-variance-authority';

const rangeTrackBaseStyles = ['relative', 'w-full'];

const rangeTrackStylesSAG = cva([
  ...rangeTrackBaseStyles,
  'h-1',
  'bg-[#CCCCD4]',
  'dark:bg-[#66667E]',
]);

const rangeTrackStylesSHS = cva([
  ...rangeTrackBaseStyles,
  'h-0.5',
  'bg-[#999999]',
  'dark:bg-[#4d4d4d]',
]);

export { rangeTrackStylesSAG, rangeTrackStylesSHS };
